import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { getAccessToken } from '@sxm-de/dev-kits/web-sdk/utils';

interface ConfirmOrderStripeFnPayload {
    orderId: string;
    chargeAgreementVersion: string;
    locale: string;
}

export type ConfirmOrderStripeFn = (
    payload: ConfirmOrderStripeFnPayload,
) => Promise<unknown>;

export function initConfirmOrderStripeFn({
    dependencies,
    state,
    countryCodeDefault,
}: DomainInitPayload): ConfirmOrderStripeFn {
    const { appEventSdk, clientSdk, atlasSdk } = dependencies;
    return async ({ orderId, chargeAgreementVersion, locale }) => {
        const { stripePaymentMethodId } = state;

        try {
            const result: any = await atlasSdk.domains.commerce.confirmOrder({
                request: { orderId, stripePaymentMethodId },
                accessToken: getAccessToken(),
            });
            const subscriptionId = result?.newSubscription?.subscriptionId;

            appEventSdk.trackEvent({
                event: 'customer-info',
                customerInfo: {
                    customerType: 'SXIR_SELFPAY',
                    subscriptions: [
                        {
                            id: subscriptionId,
                        },
                    ],
                },
            });
            appEventSdk.trackEvent({
                event: 'order-confirmed',
                subscriptionInfo: [
                    {
                        id: subscriptionId,
                        orderId,
                    },
                ],
            });

            try {
                /**
                 * TODO:
                 * Replace this with helper if possible.
                 */
                await clientSdk.user.updateAccount({
                    privacyAgreements: [
                        {
                            version: chargeAgreementVersion,
                            language: locale,
                            consentType: 'Offer and Renewal terms',
                            countryCode: countryCodeDefault.toUpperCase(),
                            platform: 'Web',
                            appVersion: '1.0',
                        },
                    ],
                });
                if (countryCodeDefault === 'us') {
                    const privacyAgreementVersion = chargeAgreementVersion;
                    /**
                     * TODO:
                     * Replace this with helper if possible.
                     */
                    await clientSdk.user.updateAccount({
                        privacyAgreements: [
                            {
                                version: privacyAgreementVersion,
                                language: locale,
                                consentType:
                                    'Customer Agreement and Privacy policy',
                                countryCode: countryCodeDefault.toUpperCase(),
                                platform: 'Web',
                                appVersion: '1.0',
                            },
                        ],
                    });
                }
            } catch (error: any) {
                /**
                 * TODO:
                 * Log error to error logger (not analytics).
                 */
                // Requirement is to not stop the flow if any error.
            }

            return result;
        } catch (error: any) {
            state.stripePaymentMethodId = undefined;
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
